import { IKeyObjective } from 'legacy/lut/classes/models/partner360/IFormOptionsJBP'

export const filterKeyObjectives = (
  keyObjectives: IKeyObjective[],
  fYear: number | null,
  rtm: string
) =>
  keyObjectives.filter(
    (keyObjective) =>
      keyObjective.fYear === fYear && (!keyObjective.rtm || keyObjective.rtm.includes(rtm))
  )
